module.exports = __webpack_public_path__ + "robotboy_3-8e7eccc02ceef46e2029ab87d0d5bd63.png";